__turbopack_context__.v({
  "bubblePop": "styles-module-scss-module__cIfDXG__bubblePop",
  "disabledPill": "styles-module-scss-module__cIfDXG__disabledPill",
  "growIn": "styles-module-scss-module__cIfDXG__growIn",
  "pillButton": "styles-module-scss-module__cIfDXG__pillButton",
  "pillRail": "styles-module-scss-module__cIfDXG__pillRail",
  "pillsContainer": "styles-module-scss-module__cIfDXG__pillsContainer",
  "reshuffleButton": "styles-module-scss-module__cIfDXG__reshuffleButton",
});
